export {
  IsAlive777Page,
}from "./container";